import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { createPortal } from 'react-dom';
import CustomSelect from 'atoms/DropDown/CustomSelect';
import { LOCAL_STORAGE_KEYS, RESIZE, CHANGE_LANGUAGE, SET_LANGUAGE, LANGUAGE_CHANGED } from 'common/constants/SharedConstants';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { ButtonComp } from 'atoms/Buttons';
import capitalize from 'lodash/capitalize';
import { ClearCartModule } from 'organisms/ClearCartModule/Container/ClearCartComponent';
import { ReactSVG } from 'react-svg';
import { changeLanguage } from '@kfc-global/kfc-i18n/lib/i18N';
import ImageComponent from 'atoms/Image';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { isMobileDevice, redirectToHomePage } from 'common/utilities/utils';
import { useHistory } from 'react-router-dom';
import { UserOrderContext } from 'context/context';
import HEADER_CONSTANT from 'organisms/HeaderComponent/AU/HeaderConstants/HeaderConstant';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import { useAppDispatch } from '@kfc-global/react-shared/redux/Store/hooks';
import { setPWAstorage } from '@kfc-global/react-shared/redux/Slices/PwaStorageSlice';

export const globeIcon = param => {
  return param ? IMAGE_PATH.LangGlobeHeader : IMAGE_PATH.LangGlobeFooter;
};

export const LanguageSelectorMobComp = props => {
  const { allowedLanguages, onChangeHandler, onCloseModal, selectedLanguage } = props;
  return createPortal(
    <div className='root-header-au'>
      <div className='hamburger-container side-nav-open'>
        <div className='hamburger-header-container'>
          <ButtonComp className='langmodal-close-button' data-testid='langmodal-close' onClick={onCloseModal}>
            <ImageComponent srcFile={IMAGE_PATH.ArrowIcon} alt={'close'} />
          </ButtonComp>
          <span className='langmodal-label'>{translateWithI18Next(CHANGE_LANGUAGE)}</span>
        </div>
        <div className='langmodal-stripe-icon'>
          <ReactSVG src={IMAGE_PATH.Strips} />
        </div>
        <div className='langmodal-list-content'>
          {allowedLanguages.map(item => (
            <div onClick={() => onChangeHandler(null, item, item.key)} className='langmodal-list' key={item.key}>
              <span className={`langmodal-list-txt ${item.key === selectedLanguage?.key ? 'active-lang' : ''}`}>
                {item.value}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>,
    document.getElementById('modal-popups'),
  );
};
export const LanguageSelectorComp = props => {
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const [isMobile, setMobileHeader] = useState(isMobileDevice(window.innerWidth));
  const [showMobLangComp, setShowMobLangComp] = useState(false);
  const { cartData } = useSelector(data => data.cartReducer);
  const { SHOW_CLEAR_CART_ALERT } = START_ORDER_CONSTANTS;
  const history = useHistory();
  const { defaultTooltipShow, hamburgerMenu } = props;
  const sliceDispatch = useAppDispatch();
  const { defaultLanguage, allowedLanguages, COUNTRY } = useSelector(
    ({ tenantReducer: { basic: { allowedLanguages = [], defaultLanguage } = {}, country: COUNTRY = '' } = {} }) => ({
      allowedLanguages,
      defaultLanguage,
      COUNTRY,
    }),
  );
  const [selectedLanguage, setSelectedLanguage] = useState(defaultLanguage);
  const windowResized = () => {
    const isMobileView = isMobileDevice(window.innerWidth);
    setMobileHeader(isMobileView);
  };
  useEffect(() => {
    window.addEventListener(RESIZE, windowResized);
  }, [isMobile]);

  useEffect(() => {
    const localStorageLanguage = allowedLanguages.find(
      item => item?.key?.toLowerCase() === localStorage?.getItem(LOCAL_STORAGE_KEYS.USER_LANGUAGE)?.toLowerCase(),
    );
    !!COUNTRY && localStorageLanguage && setSelectedLanguage(localStorageLanguage);
  }, [COUNTRY, allowedLanguages]);

  useEffect(() => {
    if (userOrderState?.selectedLanguage && cartData?.foodLines?.length === 0 && selectedLanguage?.key !== userOrderState?.selectedLanguage) {
      updateAndReloadLanguage();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartData?.foodLines?.length]);

  const updateAndReloadLanguage = (value) => {
    sliceDispatch(setPWAstorage({ key: LANGUAGE_CHANGED, value: LANGUAGE_CHANGED }));
    const lang = value || userOrderState?.selectedLanguage || selectedLanguage?.key;
    changeLanguage(lang);
    localStorage.setItem(LOCAL_STORAGE_KEYS?.USER_LANGUAGE, lang);
    redirectToHomePage({ history });
    setTimeout(() => window.location.reload(), 1000);
  }

  const onCloseModal = () => {
    setShowMobLangComp(false);
  };

  const onChangeHandler = (event, item, value) => {
    document.documentElement.setAttribute('lang',value?.slice(0,2));
    if (selectedLanguage?.key === value) {
      return;
    }
    if (cartData?.foodLines?.length > 0) {
      userOrderStateDispatch({
        type: SET_LANGUAGE,
        value: { selectedLanguage: value },
      });
      userOrderStateDispatch({
        type: SHOW_CLEAR_CART_ALERT,
        value: { showCartClearAlert: true },
      });
    } else {
      updateAndReloadLanguage(value);
    }
  };
  const placeHolderValue = () => {
    return hamburgerMenu ? capitalize(selectedLanguage?.short_value) : selectedLanguage?.value;
  };
  return (
    <div
      data-testid='language-selector-container'
      className={`language-selector-container${allowedLanguages?.length <= 1 ? ' no-border' : ''}`}
    >
      {allowedLanguages?.length > 1 && (
        <div>
          {!isMobile && (
            <div className='lang-selector-wrapper'>
              <ImageComponent
                className='lang-globe-icon'
                srcFile={globeIcon(defaultTooltipShow)}
                alt={HEADER_CONSTANT.LANGUAGE_SELECTOR}
              />
              <CustomSelect
                source={allowedLanguages}
                optionLabelFieldName='value'
                optionValueFieldName='key'
                placeholder={placeHolderValue()}
                langSelector={true}
                onChange={onChangeHandler}
              ></CustomSelect>
            </div>
          )}
          {isMobile && (
            <div>
              <div
                className='lang-selector-wrapper mob'
                data-testid='lang-select-mob-component'
                onClick={() => setShowMobLangComp(true)}
              >
                <ImageComponent
                  className='lang-globe-icon'
                  srcFile={globeIcon(hamburgerMenu)}
                  alt={HEADER_CONSTANT.LANGUAGE_SELECTOR}
                />
                <span>{placeHolderValue()}</span>
              </div>
            </div>
          )}
          {showMobLangComp && (
            <LanguageSelectorMobComp
              data-testid='languageSelectorMobComp'
              selectedLanguage={selectedLanguage}
              allowedLanguages={allowedLanguages}
              onChangeHandler={onChangeHandler}
              onCloseModal={onCloseModal}
            />
          )}
          {userOrderState.showCartClearAlert ? <ClearCartModule langSelector={true} /> : null}
        </div>
      )}
    </div>
  );
};
